import { render } from "./CustomToggle.vue?vue&type=template&id=20371d78"
import script from "./CustomToggle.vue?vue&type=script&lang=js"
export * from "./CustomToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__